import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { SnackbarErrorMessage } from '@ui-components/components/customized-snackbar/snackbar-message.enum';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

import {
  createResponsibleParties,
  createResponsiblePartiesFailure,
  createResponsiblePartiesSuccess,
  loadResponsibleParties,
  loadResponsiblePartiesFailure,
  loadResponsiblePartiesSuccess,
  updateResponsibleParties,
  updateResponsiblePartiesFailure,
  updateResponsiblePartiesSuccess,
} from '../actions/turnover-configuration-step-assignees.actions';
import { TurnoverConfigurationStepAssigneesService } from '../services/turnover-configuration-step-assignees.service';

@Injectable()
export class TurnoverConfigurationStepAssigneesEffects {
  loadResponsibleParties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadResponsibleParties),
      switchMap(action =>
        this.responsiblePartiesService.getResponsiblePartiesByPortfolioId(action.portfolioId).pipe(
          map(responsibleParties => loadResponsiblePartiesSuccess({ responsibleParties: responsibleParties || [] })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.WhileLoadingResponsibleParties);
            return of(loadResponsiblePartiesFailure());
          })
        )
      )
    )
  );

  createResponsibleParties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createResponsibleParties),
      mergeMap(action =>
        this.responsiblePartiesService.createResponsibleParties(action.responsibleParties).pipe(
          map(createResponsibleParties => createResponsiblePartiesSuccess({ createResponsibleParties })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.WhileCreatingAssignee);
            return of(createResponsiblePartiesFailure());
          })
        )
      )
    )
  );

  updateResponsibleParties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateResponsibleParties),
      mergeMap(action =>
        this.responsiblePartiesService.updateResponsibleParties(action.responsibleParties).pipe(
          map(updateResponsibleParties => updateResponsiblePartiesSuccess({ updateResponsibleParties })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.WhileUpdatingAssignee);
            return of(updateResponsiblePartiesFailure());
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private snackbarService: SnackbarService,
    private responsiblePartiesService: TurnoverConfigurationStepAssigneesService
  ) {}
}
